'use client';

export * from 'swr';

export { default as useSWR } from 'swr';
export { default as useSWRInfinite } from 'swr/infinite';
